import { render, staticRenderFns } from "./ProductTileRating.vue?vue&type=template&id=72bc6d5f&"
import script from "./ProductTileRating.vue?vue&type=script&lang=js&"
export * from "./ProductTileRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RatingStars: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/RatingStars.vue').default})
